export default __webpack_public_path__ + "static/media/avatars(6).96d840a6.png";